"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.preloadData = void 0;
var tslib_1 = require("tslib");
var wix_experiments_1 = tslib_1.__importDefault(require("@wix/wix-experiments"));
var createI18nInstance_1 = require("./i18n/createI18nInstance");
var fetchPaymentMethods_1 = require("./serverAPI/fetchPaymentMethods");
var preloadData = function (props) {
    var _a, _b;
    var experiments = new wix_experiments_1.default({
        useNewApi: true,
        scope: 'payments',
        onError: function (error) {
            console.error('Error in loading experiments:', error);
        },
    });
    return {
        i18nInstance: (0, createI18nInstance_1.createI18nInstance)(props.locale),
        experiments: experiments,
        paymentMethodsPromise: (0, fetchPaymentMethods_1.fetchPaymentMethods)({
            baseURL: '/',
            appDefId: (_a = props.meta) === null || _a === void 0 ? void 0 : _a.appDefId,
            appInstanceId: (_b = props.meta) === null || _b === void 0 ? void 0 : _b.appInstanceId,
            auth: {
                appInstance: props.meta.appInstance,
                revalidateAppInstance: props.revalidateAppInstance,
            },
        }),
    };
};
exports.preloadData = preloadData;
//# sourceMappingURL=preloadData.js.map